import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=47c59fca"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=47c59fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports